import spacing from 'material-ui/styles/spacing';

// Logo colors: purple: #262360 , orange #f1603d , blue: #1478b9
export default {
    spacing: spacing,
    fontFamily: 'Roboto, sans-serif',
    palette: {
        primary1Color: '#262360',
        primary2Color: '#262360',
        primary3Color: '#1478b9',
        accent1Color: '#d32f2f',
        accent2Color: '#f5f5f5',
        accent3Color: '#9e9e9e',
        textColor: '#212121',
        alternateTextColor: '#ffffff',
        canvasColor: '#ffffff',
        contentCanvasColor: '#edecec',
        lightCanvasColor: 'rgba(255,255,255,0.3)',
        borderColor: '#e0e0e0',
        lightTextColor: 'rgba(33,33,33,0.5)', // #212121
        disabledColor: 'rgba(33,33,33,0.3)', // #212121
        pickerHeaderColor: '#1478b9',
        avatarColor: '#f1603d',
        clockCircleColor: 'rgba(33,33,33,0.7)', // #212121
        shadowColor: '#212121',
        correctColor: '#66bb6a',
        errorColor: '#f44336',
        modifiedColor: '#d4f0ff',
    },
};



// WEBPACK FOOTER //
// ./src/Fuse/global/theme.js